import { REPORT_STATUS_ENUM } from '../types/enums'

export const getReportTranslatedStatus = (reportStatus: REPORT_STATUS_ENUM) => {
  if (reportStatus === REPORT_STATUS_ENUM.DONE) return 'Готов'
  if (reportStatus === REPORT_STATUS_ENUM.ERROR) return 'Ошибка'
  if (reportStatus === REPORT_STATUS_ENUM.PROCESSING) return 'Обработка'
  return reportStatus
}
